<template>
  <v-layout row wrap fluid>
    <v-flex>
      <v-card class="add-card max-shadow">
        <v-card-title primary-title>
          <div class="headline">New Tenant</div>
          <v-spacer />
          <v-btn color="primary" flat @click="addTenant">
            <v-layout v-if="loading" row wrap justify-center>
              <v-progress-circular
                :size="24"
                :width="3"
                indeterminate
                color="primary"
              />
            </v-layout>
            <v-layout v-else row wrap justify-center> add </v-layout>
          </v-btn>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-lg fluid class="pa-3">
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="companyName"
                  v-model="companyName"
                  :rules="[(v) => !!v || 'Company Name is required']"
                  autofocus
                  name="company-name"
                  label="Company Name"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="adminName"
                  v-model="admin.name"
                  :rules="[(v) => !!v || 'Admin Name is required']"
                  name="admin-name"
                  label="Admin Name"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="adminEmail"
                  v-model="admin.email"
                  :rules="validationRules.email"
                  name="admin-email"
                  label="Admin Email"
                  type="email"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6 d-flex align-center>
                <v-text-field
                  ref="adminPhone"
                  v-model="admin.phone"
                  :rules="validationRules.phone"
                  mask="##########"
                  prefix="+91"
                  name="admin-phone"
                  label="Admin Phone"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-layout row>
                  <v-menu
                    ref="date_menu"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="moveInDate"
                    class="flex"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="moveInDate"
                      label="Move In Date"
                      prepend-icon="event"
                      readonly
                    />
                    <v-date-picker
                      v-model="moveInDate"
                      :max="maxDate"
                      no-title
                      scrollable
                      color="primary"
                    >
                      <v-spacer />
                      <v-btn flat color="primary" @click="datePicker = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.date_menu.save(moveInDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="time_menu"
                    v-model="timePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="moveInTime"
                    class="flex"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedMoveInTime"
                      label="Move In Time"
                      prepend-icon="access_time"
                      readonly
                    />
                    <v-time-picker
                      v-model="moveInTime"
                      :max="maxTime"
                      scrollable
                      color="primary"
                    >
                      <v-spacer />
                      <v-btn flat color="primary" @click="timePicker = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.time_menu.save(moveInTime)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-subheader>Billing Address</v-subheader>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="billingAddress.line1"
                  :rules="[(v) => !!v || 'Address Line 1 is required']"
                  label="Address Line 1"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="billingAddress.line2"
                  label="Address Line 2"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="billingAddress.city"
                  :rules="[(v) => !!v || 'City is required']"
                  label="City"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="billingAddress.state"
                  :rules="[(v) => !!v || 'State is required']"
                  label="State"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="billingAddress.pincode"
                  :rules="[(v) => !!v || 'Pincode is required']"
                  label="Pincode"
                  mask="######"
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0" bottom>
        {{ snackbarMessage }}
        <v-btn flat @click.native="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';

import validationRules from '@/mixins/validation-rules';
import { firestore, auth } from '@/firebase';
import axios from 'axios';
import { settings } from '../../../utils/settings';

export default {
  name: 'NewTenant',
  mixins: [validationRules],
  data() {
    return {
      companyName: '',
      admin: {
        name: '',
        email: '',
        phone: '',
      },
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary',
      billingAddress: {},
      datePicker: false,
      timePicker: false,
      dateFormat: 'YYYY-MM-DD',
      moveInDate: moment().format('YYYY-MM-DD'),
      moveInTime: moment().format('HH:mm'),
      loading: false,
    };
  },
  computed: {
    adminFormatted() {
      return {
        name: this.admin.name,
        email: this.admin.email,
        phone: `+91${this.admin.phone}`,
      };
    },

    maxDate() {
      return moment().format(this.dateFormat);
    },

    maxTime() {
      return moment(this.moveInDate).isSame(moment(), 'day')
        ? moment().format('HH:mm')
        : '23:59';
    },

    formattedMoveInTime() {
      return moment(this.moveInTime, 'HH:mm').format('hh:mm A');
    },

    moveInDateTime() {
      return moment(
        `${this.moveInDate} ${this.moveInTime}`,
        `${this.dateFormat} HH:mm`
      ).toDate();
    },
  },
  methods: {
    getIdToken() {
      return auth.currentUser.getIdToken();
    },
    async addTenant() {
      if (this.loading) return;

      if (!this.$refs.form.validate()) return;

      this.loading = true;

      const idToken = await this.getIdToken();

      await axios
        .post(
          `${settings.dashboard_url}/api/user/exists`,
          {
            user: this.adminFormatted,
          },
          {
            headers: {
              authorization: `idToken ${idToken}`,
            },
          }
        )
        .then(() => {
          firestore.collection('tenants').add({
            companyName: this.companyName,
            admin: this.adminFormatted,
            moveInTime: this.moveInDateTime,
          });

          this.$router.push('/max-admin/tenants');
        })
        .catch((error) => {
          const errorMessages =
            ((error.response || {}).data || {}).error || error.message;
          console.log(errorMessages);
          this.snackbarMessage = errorMessages;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });

      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
